/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ConsentResponse = {
  category: ConsentResponse.category;
  status: boolean;
  consentDate: string;
};
export namespace ConsentResponse {
  export enum category {
    VEHICLE_INSPECTION = 'VEHICLE_INSPECTION',
    HIGHWAY_UNPAID = 'HIGHWAY_UNPAID',
    LICENSE_RENEWAL = 'LICENSE_RENEWAL',
    DEMERIT_EDUCATION = 'DEMERIT_EDUCATION',
  }
}

